import campaigns from './campaigns'
import opportunities from './opportunities'
import organizations from './organizations'
import users from './users'

export default [
  ...campaigns,
  ...opportunities,
  ...organizations,
  ...users,
  {
    path: '/client/applications',
    meta: { auth: 'client' },
    component: () => import(/* webpackChunkName: "client-applications" */ "@/views/client/Applications.vue")
  },
  {
    path: '/client/analytics',
    meta: { auth: 'client' },
    component: () => import(/* webpackChunkName: "client-analytics" */ "@/views/client/Analytics.vue")
  },
  {
    path: '/client/analytics/explorer',
    meta: { auth: 'client' },
    component: () => import(/* webpackChunkName: "client-analytics" */ "@/views/client/AnalyticsExplorer.vue")
  },
  {
    path: '/client/analytics/campaigns',
    meta: { auth: 'client' },
    component: () => import(/* webpackChunkName: "client-analytics" */ "@/views/client/CampaignAnalytics.vue")
  },
  {
    path: '/client/shared_candidates',
    meta: { auth: 'client' },
    props: true,
    component: () => import(/* webpackChunkName: "client-feedback-requests" */ "@/views/client/FeedbackRequests.vue")
  },
  {
    path: '/client/billing',
    meta: { auth: 'client' },
    component: () => import(/* webpackChunkName: "client-billing" */ "@/views/client/Billing.vue")
  },
]
